exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".weekday{color:red;font-weight:700}", ""]);

// exports
